import {
    VIDEO_PREPARE_START,
    VIDEO_PREPARE_SUCCESS,
    VIDEO_PREPARE_ERROR,
    VIDEO_CAN_AUTOPLAY,
} from '../actions/video';

const initialState = {
    videos: {},
    errors: {},
    autoplay: false,
};

export default function videoPlaybackReducer(state = initialState, action) {
    switch (action.type) {
        case VIDEO_PREPARE_START: {
            let errors = {...state.errors};
            delete errors[action.id];
            return {...state, errors};
        }

        case VIDEO_PREPARE_SUCCESS:
            let videos = {...state.video};
            videos[action.id] = action.payload;
            return {...state, videos};

        case VIDEO_PREPARE_ERROR:
            let errors = {...state.errors};
            errors[action.id] = action.error;
            return {...state, errors};
        case VIDEO_CAN_AUTOPLAY:
            return {...state, autoplay: action.autoplay};
        default:
            return state;
    }
}
